/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface ApiUsersList200Response
 */
export interface ApiUsersList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiUsersList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiUsersList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiUsersList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<User>}
   * @memberof ApiUsersList200Response
   */
  results: Array<User>;
}

/**
 * Check if a given object implements the ApiUsersList200Response interface.
 */
export function instanceOfApiUsersList200Response(value: object): value is ApiUsersList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiUsersList200ResponseFromJSON(json: any): ApiUsersList200Response {
  return ApiUsersList200ResponseFromJSONTyped(json, false);
}

export function ApiUsersList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiUsersList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(UserFromJSON),
  };
}

export function ApiUsersList200ResponseToJSON(json: any): ApiUsersList200Response {
  return ApiUsersList200ResponseToJSONTyped(json, false);
}

export function ApiUsersList200ResponseToJSONTyped(
  value?: ApiUsersList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(UserToJSON),
  };
}
